import axios from 'axios'
import type {
  ApiResponse,
  FieldConfiguration,
  CreateFieldConfigRequest,
  Client,
  ClientResponse,
  ClientListFilters,
  ClientListResponse,
  CreateClientRequest,
  Business,
  BusinessResponse,
  CreateBusinessRequest,
  UpdateBusinessRequest,
  EntityType,
  BillingTemplate,
  CreateBillingTemplateRequest,
  UpdateBillingTemplateRequest,
  InvoiceResponse,
  InvoiceListItem,
  CreateInvoiceRequest,
  UpdateInvoiceRequest,
  InvoiceStatus,
  InvoiceSettings,
  UpdateInvoiceSettingsRequest,
  AgencyConfiguration,
  UpdateAgencyConfigurationRequest,
  TaxMaster,
  TaxMasterListItem,
  CreateTaxMasterRequest,
  UpdateTaxMasterRequest,
  FeesMaster,
  FeesMasterListItem,
  CreateFeesMasterRequest,
  UpdateFeesMasterRequest,
  CountryMaster,
  CountryListItem,
  CreateCountryRequest,
  UpdateCountryRequest,
  CurrencyMaster,
  CurrencyListItem,
  CreateCurrencyRequest,
  UpdateCurrencyRequest,
  EmailTemplate,
  EmailTemplateListItem,
  CreateEmailTemplateRequest,
  UpdateEmailTemplateRequest,
  EmailTemplatePlaceholder,
  CategoryMaster,
  CategoryMasterListItem,
  CreateCategoryMasterRequest,
  UpdateCategoryMasterRequest,
  CategoryType,
  ProductMaster,
  ProductMasterListItem,
  CreateProductMasterRequest,
  UpdateProductMasterRequest,
  ProductType,
  PaymentMethodMaster,
  PaymentMethodListItem,
  CreatePaymentMethodRequest,
  UpdatePaymentMethodRequest,
  ExchangeRate,
  ConversionPreview,
  CreateExchangeRateRequest,
  RecurringInvoiceResponse,
  RecurringInvoiceListItem,
  CreateRecurringInvoiceRequest,
  UpdateRecurringInvoiceRequest,
  RecurringInvoiceStatus,
  QuoteResponse,
  QuoteListItem,
  CreateQuoteRequest,
  UpdateQuoteRequest,
  QuoteStatus,
  ConvertToInvoiceRequest,
  ConvertToInvoiceResponse,
  Screen,
  Role,
  RoleListItem,
  CreateRoleRequest,
  UpdateRoleRequest,
  User,
  UserListItem,
  CreateUserRequest,
  UpdateUserRequest,
  InvoicePayment,
  InvoicePaymentResponse,
  RecordPaymentRequest,
  DashboardResponse,
  Expense,
  ExpenseListItem,
  CreateExpenseRequest,
  UpdateExpenseRequest,
  // Project Management types
  Project,
  CreateProjectRequest,
  UpdateProjectRequest,
  ProjectMember,
  AddProjectMemberRequest,
  UpdateProjectMemberRequest,
  Board,
  CreateBoardRequest,
  UpdateBoardRequest,
  BoardWithLists,
  BoardList,
  CreateBoardListRequest,
  UpdateBoardListRequest,
  BoardLabel,
  CreateBoardLabelRequest,
  UpdateBoardLabelRequest,
  BoardMember,
  AddBoardMemberRequest,
  UpdateBoardMemberRequest,
  BoardCard,
  CreateBoardCardRequest,
  UpdateBoardCardRequest,
  MoveCardRequest,
  ReorderListsRequest,
  ReorderCardsRequest,
  CardChecklist,
  CreateChecklistRequest,
  ChecklistItem,
  CreateChecklistItemRequest,
  UpdateChecklistItemRequest,
  CardComment,
  CreateCommentRequest,
  CardDependency,
  CreateDependencyRequest,
  // Tenant Management types
  TenantWithStats,
  CreateTenantRequest,
  CreateTenantResponse,
  UpdateTenantRequest,
  UpdateTierRequest,
  ReactivateTenantRequest,
  SubscriptionHistory,
  // Support Tickets types
  SupportTicket,
  SupportTicketWithUser,
  CreateTicketRequest,
  UpdateTicketRequest,
  UpdateTicketStatusRequest,
  TicketListFilters,
  TicketAttachment,
  TicketComment,
  CreateTicketCommentRequest,
  // Audit Log types
  AuditLog,
  AuditLogFilters,
  AuditLogPage,
  // Time Tracking types
  TimeEntry,
  CreateTimeEntryRequest,
  UpdateTimeEntryRequest,
  StartTimerRequest,
  StopTimerRequest,
  TimeEntryFilters,
  TimeReportFilters,
  TimeReportSummary,
  DailySummary,
  ProjectSummary,
  UserSummary,
  // CRM types
  Lead,
  LeadSource,
  LeadStatus,
  LeadTag,
  CreateLeadRequest,
  UpdateLeadRequest,
  CreateLeadSourceRequest,
  UpdateLeadSourceRequest,
  CreateLeadStatusRequest,
  UpdateLeadStatusRequest,
  ReorderLeadStatusesRequest,
  CreateLeadTagRequest,
  UpdateLeadTagRequest,
  AssignLeadRequest,
  ConvertLeadRequest,
  LeadListFilters,
  LeadListResponse,
  // Pipeline & Deal types
  Pipeline,
  PipelineStage,
  CreatePipelineRequest,
  UpdatePipelineRequest,
  CreatePipelineStageRequest,
  UpdatePipelineStageRequest,
  ReorderPipelineStagesRequest,
  Deal,
  CreateDealRequest,
  UpdateDealRequest,
  MoveDealRequest,
  WonDealRequest,
  LostDealRequest,
  AssignDealRequest,
  UpdateDealPositionsRequest,
  DealListFilters,
  DealListResponse,
  KanbanBoardResponse,
  KanbanBoardFilters,
  // Activity & Reminder types
  Activity,
  CreateActivityRequest,
  UpdateActivityRequest,
  ActivityListFilters,
  ActivityListResponse,
  TimelineResponse,
  TaskSummary,
  CRMEntityType,
  Reminder,
  CreateReminderRequest,
  UpdateReminderRequest,
  SnoozeReminderRequest,
  ReminderListFilters,
  ReminderListResponse,
  UpcomingRemindersResponse,
  // Automation types
  AutomationRule,
  CreateAutomationRequest,
  UpdateAutomationRequest,
  AutomationListFilters,
  AutomationListResponse,
  AutomationLogListFilters,
  AutomationLogListResponse,
  // CRM Dashboard & Reports types
  CRMDashboardRequest,
  LeadFunnelResponse,
  PipelineOverviewResponse,
  ActivitySummaryResponse,
  SalesForecastResponse,
  LeadSourceStatsResponse,
  DealsByOwnerResponse,
  CRMReportFilters,
  LeadReportResponse,
  PipelineReportResponse,
  ActivityReportResponse,
  ConversionReportResponse,
  SalesReportResponse,
  SendLeadEmailRequest,
  SendDealEmailRequest,
  SendEmailResponse,
  // Contract types
  ContractTemplate,
  ContractTemplateListItem,
  CreateContractTemplateRequest,
  UpdateContractTemplateRequest,
  Contract,
  ContractListItem,
  CreateContractRequest,
  UpdateContractRequest,
  ContractFilters,
  ContractSigner,
  SendForSigningRequest,
  AddSignerRequest,
  SigningLinkResponse,
  SignContractRequest,
  DeclineContractRequest,
  PublicContractView,
  RequestOTPResponse,
  VerifyOTPRequest,
  VerifyOTPResponse,
  ContractVersion,
  ContractAuditLog,
  // Scheduler types
  SchedulerConfig,
  SchedulerConfigListItem,
  UpdateSchedulerConfigRequest,
  ExecutionHistoryResponse,
  SchedulerStatusResponse,
  TriggerJobRequest,
  TriggerJobResponse,
  JobType,
  JobStatus,
  // E-Signing types
  ESigningProviderMeta,
  ESigningSettings,
  UpdateESigningSettingsRequest,
  ESigningTestConnectionResponse,
  // Social Media Calendar types
  SocialMediaCalendar,
  CreateSocialMediaCalendarRequest,
  UpdateSocialMediaCalendarRequest,
  SocialMediaCalendarFilters,
  SocialMediaAccount,
  CreateSocialMediaAccountRequest,
  UpdateSocialMediaAccountRequest,
  SocialMediaPost,
  CreateSocialMediaPostRequest,
  UpdateSocialMediaPostRequest,
  SocialMediaPostFilters,
  RejectPostRequest,
  SocialMediaPostComment,
  CreatePostCommentRequest,
  CalendarMember,
  AddCalendarMemberRequest,
  UpdateCalendarMemberRequest,
  // Social Media Account credential types
  TestConnectionRequest,
  TestConnectionResponse,
  PlatformInfo,
  // Social Media Publishing types
  PublishPostRequest,
  PublishPostResponse,
  PostPublishLog,
  PublishLogStatus,
} from '@/types'

// API base URL for public endpoints
const API_BASE_URL = '/api'

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Storage keys
const TOKEN_KEY = 'auth_token'

// Add auth token to all requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY)
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
})

// Subscription inactive error code - used when trial expires or agency is inactive
export const SUBSCRIPTION_INACTIVE_CODE = 'SUBSCRIPTION_INACTIVE'

// Custom event for subscription inactive errors
export const SUBSCRIPTION_INACTIVE_EVENT = 'subscription:inactive'

// Handle API response unwrapping and 401 responses
api.interceptors.response.use(
  (response) => {
    // Check if response has the new API wrapper format
    const data = response.data
    if (data && typeof data === 'object' && 'success' in data && 'data' in data) {
      // Unwrap the response and attach pagination if present
      const apiResponse = data as ApiResponse
      response.data = apiResponse.data

      // Attach pagination metadata to response object for easy access
      if (apiResponse.pagination) {
        (response as any).pagination = apiResponse.pagination
      }
    }
    return response
  },
  (error) => {
    if (error.response?.status === 401) {
      // Clear auth data and redirect to login
      localStorage.removeItem(TOKEN_KEY)
      localStorage.removeItem('auth_user')
      localStorage.removeItem('tenant_id')
      localStorage.removeItem('user_id')

      // Only redirect if not already on login page
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login'
      }
    }

    // Handle subscription inactive (trial expired or agency inactive)
    if (error.response?.status === 403 && error.response?.data?.code === SUBSCRIPTION_INACTIVE_CODE) {
      // Dispatch custom event for components to listen to
      window.dispatchEvent(new CustomEvent(SUBSCRIPTION_INACTIVE_EVENT, {
        detail: {
          message: error.response.data.error || 'Your subscription is inactive',
        }
      }))
    }

    return Promise.reject(error)
  }
)

// Custom Field Configuration API
export const customFieldsApi = {
  getAll: async (entityType?: EntityType): Promise<FieldConfiguration[]> => {
    const params = entityType ? { entity_type: entityType } : {}
    const response = await api.get('/settings/custom-fields', { params })
    return response.data
  },

  create: async (data: CreateFieldConfigRequest): Promise<FieldConfiguration> => {
    const response = await api.post('/settings/custom-fields', data)
    return response.data
  },

  delete: async (configId: string): Promise<void> => {
    await api.delete(`/settings/custom-fields/${configId}`)
  },
}

// Client API
export const clientsApi = {
  getAll: async (filters?: ClientListFilters): Promise<ClientListResponse> => {
    const response = await api.get('/clients', { params: filters })
    return response.data
  },

  // Legacy method for backward compatibility - fetches all clients
  // Automatically handles pagination if there are more than 500 clients
  getAllLegacy: async (): Promise<Client[]> => {
    const pageSize = 500 // Max allowed by backend
    let allClients: Client[] = []
    let currentPage = 1
    let hasMore = true

    while (hasMore) {
      const response = await api.get('/clients', {
        params: { page: currentPage, page_size: pageSize }
      })
      const data = response.data as ClientListResponse

      if (data.clients && data.clients.length > 0) {
        allClients = [...allClients, ...data.clients]
        hasMore = currentPage < data.total_pages
        currentPage++
      } else {
        hasMore = false
      }
    }

    return allClients
  },

  getById: async (id: string): Promise<ClientResponse> => {
    const response = await api.get(`/clients/${id}`)
    return response.data
  },

  create: async (data: CreateClientRequest): Promise<ClientResponse> => {
    const response = await api.post('/clients', data)
    return response.data
  },

  update: async (id: string, data: Partial<CreateClientRequest>): Promise<ClientResponse> => {
    const response = await api.put(`/clients/${id}`, data)
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/clients/${id}`)
  },
}

// Business API
export const businessesApi = {
  getAll: async (clientId: string): Promise<Business[]> => {
    const response = await api.get(`/clients/${clientId}/businesses`)
    return response.data
  },

  getById: async (businessId: string): Promise<BusinessResponse> => {
    const response = await api.get(`/businesses/${businessId}`)
    return response.data
  },

  create: async (clientId: string, data: CreateBusinessRequest): Promise<BusinessResponse> => {
    const response = await api.post(`/clients/${clientId}/businesses`, data)
    return response.data
  },

  update: async (businessId: string, data: UpdateBusinessRequest): Promise<BusinessResponse> => {
    const response = await api.put(`/businesses/${businessId}`, data)
    return response.data
  },

  delete: async (clientId: string, businessId: string): Promise<void> => {
    await api.delete(`/clients/${clientId}/businesses/${businessId}`)
  },
}

// Billing Template API (shared for invoices and quotes)
export const billingTemplatesApi = {
  getAll: async (type?: 'INVOICE' | 'QUOTE'): Promise<BillingTemplate[]> => {
    const params = type ? { type } : {}
    const response = await api.get('/billing/billing-templates', { params })
    return response.data
  },

  getById: async (id: string): Promise<BillingTemplate> => {
    const response = await api.get(`/billing/billing-templates/${id}`)
    return response.data
  },

  getDefault: async (type: 'INVOICE' | 'QUOTE' = 'INVOICE'): Promise<BillingTemplate> => {
    const response = await api.get('/billing/billing-templates/default', { params: { type } })
    return response.data
  },

  create: async (data: CreateBillingTemplateRequest): Promise<BillingTemplate> => {
    const response = await api.post('/billing/billing-templates', data)
    return response.data
  },

  update: async (id: string, data: UpdateBillingTemplateRequest): Promise<BillingTemplate> => {
    const response = await api.put(`/billing/billing-templates/${id}`, data)
    return response.data
  },

  setDefault: async (id: string): Promise<BillingTemplate> => {
    const response = await api.put(`/billing/billing-templates/${id}/default`)
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/billing/billing-templates/${id}`)
  },
}

// Alias for backward compatibility
export const invoiceTemplatesApi = billingTemplatesApi

// Invoice API
export interface InvoiceFilters {
  status?: InvoiceStatus
  client_id?: string
  invoice_number?: string
  client_name?: string
  invoice_date_from?: string
  invoice_date_to?: string
  due_date_from?: string
  due_date_to?: string
}

export const invoicesApi = {
  getAll: async (filters?: InvoiceFilters): Promise<InvoiceListItem[]> => {
    const response = await api.get('/billing/invoices', { params: filters })
    return response.data
  },

  getById: async (id: string): Promise<InvoiceResponse> => {
    const response = await api.get(`/billing/invoices/${id}`)
    return response.data
  },

  create: async (data: CreateInvoiceRequest): Promise<InvoiceResponse> => {
    const response = await api.post('/billing/invoices', data)
    return response.data
  },

  update: async (id: string, data: UpdateInvoiceRequest): Promise<InvoiceResponse> => {
    const response = await api.put(`/billing/invoices/${id}`, data)
    return response.data
  },

  updateStatus: async (id: string, status: InvoiceStatus): Promise<InvoiceResponse> => {
    const response = await api.put(`/billing/invoices/${id}/status`, { status })
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/billing/invoices/${id}`)
  },

  downloadPdf: async (id: string): Promise<Blob> => {
    const response = await api.get(`/billing/invoices/${id}/pdf`, {
      responseType: 'blob',
    })
    return response.data
  },

  previewPdf: async (id: string): Promise<Blob> => {
    const response = await api.get(`/billing/invoices/${id}/preview`, {
      responseType: 'blob',
    })
    return response.data
  },

  sendInvoice: async (id: string, data: {
    to_emails: string[]
    subject?: string
    message?: string
  }): Promise<{ success: boolean; message: string }> => {
    const response = await api.post(`/billing/invoices/${id}/send`, data)
    return response.data
  },

  // Payment methods
  getPayments: async (id: string): Promise<InvoicePaymentResponse> => {
    const response = await api.get(`/billing/invoices/${id}/payments`)
    return response.data
  },

  recordPayment: async (id: string, data: RecordPaymentRequest): Promise<InvoicePayment> => {
    const response = await api.post(`/billing/invoices/${id}/payments`, data)
    return response.data
  },

  deletePayment: async (invoiceId: string, paymentId: string): Promise<void> => {
    await api.delete(`/billing/invoices/${invoiceId}/payments/${paymentId}`)
  },
}

// Invoice Settings API
export const invoiceSettingsApi = {
  get: async (): Promise<InvoiceSettings> => {
    const response = await api.get('/billing/settings/invoice')
    return response.data
  },

  update: async (data: UpdateInvoiceSettingsRequest): Promise<InvoiceSettings> => {
    const response = await api.put('/billing/settings/invoice', data)
    return response.data
  },

  getNextNumber: async (): Promise<{ next_invoice_number: string }> => {
    const response = await api.get('/billing/settings/invoice/next-number')
    return response.data
  },
}

// Agency Configuration API
export const agencyConfigApi = {
  get: async (): Promise<AgencyConfiguration> => {
    const response = await api.get('/settings/agency')
    return response.data
  },

  update: async (data: UpdateAgencyConfigurationRequest): Promise<AgencyConfiguration> => {
    const response = await api.put('/settings/agency', data)
    return response.data
  },

  testSmtp: async (data: {
    smtp_host: string
    smtp_port: number
    smtp_username?: string
    smtp_password?: string
    smtp_encryption?: string
  }): Promise<{ success: boolean; message?: string; error?: string }> => {
    const response = await api.post('/settings/agency/test-smtp', data)
    return response.data
  },
}

// Tax Master API
export const taxMasterApi = {
  getAll: async (activeOnly?: boolean): Promise<TaxMasterListItem[]> => {
    const params = activeOnly ? { active_only: 'true' } : {}
    const response = await api.get('/masters/taxes', { params })
    return response.data
  },

  getById: async (id: string): Promise<TaxMaster> => {
    const response = await api.get(`/masters/taxes/${id}`)
    return response.data
  },

  create: async (data: CreateTaxMasterRequest): Promise<TaxMaster> => {
    const response = await api.post('/masters/taxes', data)
    return response.data
  },

  update: async (id: string, data: UpdateTaxMasterRequest): Promise<TaxMaster> => {
    const response = await api.put(`/masters/taxes/${id}`, data)
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/masters/taxes/${id}`)
  },
}

// Fees Master API
export const feesMasterApi = {
  getAll: async (activeOnly?: boolean): Promise<FeesMasterListItem[]> => {
    const params = activeOnly ? { active_only: 'true' } : {}
    const response = await api.get('/masters/fees', { params })
    return response.data
  },

  getById: async (id: string): Promise<FeesMaster> => {
    const response = await api.get(`/masters/fees/${id}`)
    return response.data
  },

  create: async (data: CreateFeesMasterRequest): Promise<FeesMaster> => {
    const response = await api.post('/masters/fees', data)
    return response.data
  },

  update: async (id: string, data: UpdateFeesMasterRequest): Promise<FeesMaster> => {
    const response = await api.put(`/masters/fees/${id}`, data)
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/masters/fees/${id}`)
  },
}

// Country Master API (Global - managed by Super Admin)
export const countryMasterApi = {
  // Public endpoint for dropdowns (all authenticated users)
  getAll: async (activeOnly?: boolean): Promise<CountryListItem[]> => {
    const params = activeOnly ? { active_only: 'true' } : {}
    const response = await api.get('/countries', { params })
    return response.data
  },

  // Admin endpoints (super admin only)
  getById: async (id: string): Promise<CountryMaster> => {
    const response = await api.get(`/admin/countries/${id}`)
    return response.data
  },

  create: async (data: CreateCountryRequest): Promise<CountryMaster> => {
    const response = await api.post('/admin/countries', data)
    return response.data
  },

  update: async (id: string, data: UpdateCountryRequest): Promise<CountryMaster> => {
    const response = await api.put(`/admin/countries/${id}`, data)
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/admin/countries/${id}`)
  },

  // Admin list (includes inactive)
  getAllAdmin: async (activeOnly?: boolean): Promise<CountryListItem[]> => {
    const params = activeOnly ? { active_only: 'true' } : {}
    const response = await api.get('/admin/countries', { params })
    return response.data
  },
}

// Currency Master API (Global - managed by Super Admin)
export const currencyMasterApi = {
  // Public endpoint for dropdowns (all authenticated users)
  getAll: async (activeOnly?: boolean): Promise<CurrencyListItem[]> => {
    const params = activeOnly ? { active_only: 'true' } : {}
    const response = await api.get('/currencies', { params })
    return response.data
  },

  // Admin endpoints (super admin only)
  getById: async (id: string): Promise<CurrencyMaster> => {
    const response = await api.get(`/admin/currencies/${id}`)
    return response.data
  },

  create: async (data: CreateCurrencyRequest): Promise<CurrencyMaster> => {
    const response = await api.post('/admin/currencies', data)
    return response.data
  },

  update: async (id: string, data: UpdateCurrencyRequest): Promise<CurrencyMaster> => {
    const response = await api.put(`/admin/currencies/${id}`, data)
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/admin/currencies/${id}`)
  },

  // Admin list (includes inactive)
  getAllAdmin: async (activeOnly?: boolean): Promise<CurrencyListItem[]> => {
    const params = activeOnly ? { active_only: 'true' } : {}
    const response = await api.get('/admin/currencies', { params })
    return response.data
  },
}

// Email Templates API
export const emailTemplatesApi = {
  getAll: async (): Promise<EmailTemplateListItem[]> => {
    const response = await api.get('/email-templates')
    return response.data
  },

  getById: async (id: string): Promise<EmailTemplate> => {
    const response = await api.get(`/email-templates/${id}`)
    return response.data
  },

  getByCode: async (code: string): Promise<EmailTemplate> => {
    const response = await api.get(`/email-templates/code/${code}`)
    return response.data
  },

  create: async (data: CreateEmailTemplateRequest): Promise<EmailTemplate> => {
    const response = await api.post('/email-templates', data)
    return response.data
  },

  update: async (id: string, data: UpdateEmailTemplateRequest): Promise<EmailTemplate> => {
    const response = await api.put(`/email-templates/${id}`, data)
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/email-templates/${id}`)
  },

  toggleEnabled: async (id: string): Promise<EmailTemplate> => {
    const response = await api.put(`/email-templates/${id}/toggle`)
    return response.data
  },

  getPlaceholders: async (): Promise<EmailTemplatePlaceholder[]> => {
    const response = await api.get('/email-templates/placeholders')
    return response.data
  },

  initializeDefaults: async (): Promise<{ message: string; count: number }> => {
    const response = await api.post('/email-templates/initialize')
    return response.data
  },
}

// Category Master API
export const categoryMasterApi = {
  getAll: async (activeOnly?: boolean, categoryType?: CategoryType): Promise<CategoryMasterListItem[]> => {
    const params: Record<string, string> = {}
    if (activeOnly) params.active_only = 'true'
    if (categoryType) params.category_type = categoryType
    const response = await api.get('/masters/categories', { params })
    return response.data
  },

  getById: async (id: string): Promise<CategoryMaster> => {
    const response = await api.get(`/masters/categories/${id}`)
    return response.data
  },

  create: async (data: CreateCategoryMasterRequest): Promise<CategoryMaster> => {
    const response = await api.post('/masters/categories', data)
    return response.data
  },

  update: async (id: string, data: UpdateCategoryMasterRequest): Promise<CategoryMaster> => {
    const response = await api.put(`/masters/categories/${id}`, data)
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/masters/categories/${id}`)
  },
}

// Product Master API
export const productMasterApi = {
  getAll: async (activeOnly?: boolean, productType?: ProductType): Promise<ProductMasterListItem[]> => {
    const params: Record<string, string> = {}
    if (activeOnly) params.active_only = 'true'
    if (productType) params.product_type = productType
    const response = await api.get('/masters/products', { params })
    return response.data
  },

  getById: async (id: string): Promise<ProductMaster> => {
    const response = await api.get(`/masters/products/${id}`)
    return response.data
  },

  create: async (data: CreateProductMasterRequest): Promise<ProductMaster> => {
    const response = await api.post('/masters/products', data)
    return response.data
  },

  update: async (id: string, data: UpdateProductMasterRequest): Promise<ProductMaster> => {
    const response = await api.put(`/masters/products/${id}`, data)
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/masters/products/${id}`)
  },
}

// Payment Method Master API
export const paymentMethodMasterApi = {
  getAll: async (activeOnly?: boolean): Promise<PaymentMethodListItem[]> => {
    const params = activeOnly ? { active_only: 'true' } : {}
    const response = await api.get('/masters/payment-methods', { params })
    return response.data
  },

  getById: async (id: string): Promise<PaymentMethodMaster> => {
    const response = await api.get(`/masters/payment-methods/${id}`)
    return response.data
  },

  create: async (data: CreatePaymentMethodRequest): Promise<PaymentMethodMaster> => {
    const response = await api.post('/masters/payment-methods', data)
    return response.data
  },

  update: async (id: string, data: UpdatePaymentMethodRequest): Promise<PaymentMethodMaster> => {
    const response = await api.put(`/masters/payment-methods/${id}`, data)
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/masters/payment-methods/${id}`)
  },

  setDefault: async (id: string): Promise<void> => {
    await api.post(`/masters/payment-methods/${id}/set-default`)
  },
}

// Exchange Rate API
export const exchangeRateApi = {
  getAll: async (baseCurrency?: string, startDate?: string, endDate?: string): Promise<ExchangeRate[]> => {
    const params: Record<string, string> = {}
    if (baseCurrency) params.base_currency = baseCurrency
    if (startDate) params.start_date = startDate
    if (endDate) params.end_date = endDate
    const response = await api.get('/exchange-rates', { params })
    return response.data
  },

  getLatest: async (baseCurrency: string, targetCurrency: string): Promise<ExchangeRate> => {
    const response = await api.get('/exchange-rates/latest', {
      params: { base_currency: baseCurrency, target_currency: targetCurrency }
    })
    return response.data
  },

  getConversionPreview: async (
    amount: number,
    fromCurrency: string,
    toCurrency: string,
    forexMarkup?: number,
    fixedFee?: number,
    fixedFeeCurrency?: string
  ): Promise<ConversionPreview> => {
    const params: Record<string, string | number> = {
      amount,
      from_currency: fromCurrency,
      to_currency: toCurrency,
    }
    if (forexMarkup !== undefined) params.forex_markup = forexMarkup
    if (fixedFee !== undefined) params.fixed_fee = fixedFee
    if (fixedFeeCurrency) params.fixed_fee_currency = fixedFeeCurrency
    const response = await api.get('/exchange-rates/preview', { params })
    return response.data
  },

  create: async (data: CreateExchangeRateRequest): Promise<ExchangeRate> => {
    const response = await api.post('/exchange-rates', data)
    return response.data
  },

  refresh: async (baseCurrency?: string): Promise<void> => {
    const params = baseCurrency ? { base_currency: baseCurrency } : {}
    await api.post('/exchange-rates/refresh', null, { params })
  },
}

// Recurring Invoice API
export interface RecurringInvoiceFilters {
  status?: RecurringInvoiceStatus
  client_id?: string
}

export const recurringInvoicesApi = {
  getAll: async (filters?: RecurringInvoiceFilters): Promise<RecurringInvoiceListItem[]> => {
    const response = await api.get('/billing/recurring-invoices', { params: filters })
    return response.data
  },

  getById: async (id: string): Promise<RecurringInvoiceResponse> => {
    const response = await api.get(`/billing/recurring-invoices/${id}`)
    return response.data
  },

  create: async (data: CreateRecurringInvoiceRequest): Promise<RecurringInvoiceResponse> => {
    const response = await api.post('/billing/recurring-invoices', data)
    return response.data
  },

  update: async (id: string, data: UpdateRecurringInvoiceRequest): Promise<RecurringInvoiceResponse> => {
    const response = await api.put(`/billing/recurring-invoices/${id}`, data)
    return response.data
  },

  updateStatus: async (id: string, status: RecurringInvoiceStatus): Promise<RecurringInvoiceResponse> => {
    const response = await api.put(`/billing/recurring-invoices/${id}/status`, { status })
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/billing/recurring-invoices/${id}`)
  },
}

// Quote Filters
export interface QuoteFilters {
  status?: QuoteStatus
  client_id?: string
}

// Quotes API
export const quotesApi = {
  getAll: async (filters?: QuoteFilters): Promise<QuoteListItem[]> => {
    const response = await api.get('/billing/quotes', { params: filters })
    return response.data
  },

  getById: async (id: string): Promise<QuoteResponse> => {
    const response = await api.get(`/billing/quotes/${id}`)
    return response.data
  },

  create: async (data: CreateQuoteRequest): Promise<QuoteResponse> => {
    const response = await api.post('/billing/quotes', data)
    return response.data
  },

  update: async (id: string, data: UpdateQuoteRequest): Promise<QuoteResponse> => {
    const response = await api.put(`/billing/quotes/${id}`, data)
    return response.data
  },

  updateStatus: async (id: string, status: QuoteStatus): Promise<{ message: string; status: QuoteStatus }> => {
    const response = await api.put(`/billing/quotes/${id}/status`, { status })
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/billing/quotes/${id}`)
  },

  convertToInvoice: async (id: string, data: ConvertToInvoiceRequest): Promise<ConvertToInvoiceResponse> => {
    const response = await api.post(`/billing/quotes/${id}/convert`, data)
    return response.data
  },

  downloadPdf: async (id: string): Promise<Blob> => {
    const response = await api.get(`/billing/quotes/${id}/pdf`, {
      responseType: 'blob',
    })
    return response.data
  },

  previewPdf: async (id: string): Promise<Blob> => {
    const response = await api.get(`/billing/quotes/${id}/preview`, {
      responseType: 'blob',
    })
    return response.data
  },

  sendQuote: async (id: string, data: {
    to_emails: string[]
    subject?: string
    message?: string
  }): Promise<{ success: boolean; message: string }> => {
    const response = await api.post(`/billing/quotes/${id}/send-email`, data)
    return response.data
  },
}

// Screens API
export const screensApi = {
  getAll: async (): Promise<Screen[]> => {
    const response = await api.get('/uam/screens')
    return response.data
  },
}

// Roles API
export const rolesApi = {
  getAll: async (activeOnly?: boolean): Promise<RoleListItem[]> => {
    const params = activeOnly ? { active_only: 'true' } : {}
    const response = await api.get('/uam/roles', { params })
    return response.data
  },

  getById: async (id: string): Promise<Role> => {
    const response = await api.get(`/uam/roles/${id}`)
    return response.data
  },

  create: async (data: CreateRoleRequest): Promise<Role> => {
    const response = await api.post('/uam/roles', data)
    return response.data
  },

  update: async (id: string, data: UpdateRoleRequest): Promise<Role> => {
    const response = await api.put(`/uam/roles/${id}`, data)
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/uam/roles/${id}`)
  },
}

// Users API
export const usersApi = {
  getAll: async (activeOnly?: boolean, roleId?: string): Promise<UserListItem[]> => {
    const params: Record<string, string> = {}
    if (activeOnly) params.active_only = 'true'
    if (roleId) params.role_id = roleId
    const response = await api.get('/uam/users', { params })
    return response.data
  },

  getById: async (id: string): Promise<User> => {
    const response = await api.get(`/uam/users/${id}`)
    return response.data
  },

  create: async (data: CreateUserRequest & { password?: string }): Promise<User> => {
    const response = await api.post('/uam/users', data)
    return response.data
  },

  update: async (id: string, data: UpdateUserRequest): Promise<User> => {
    const response = await api.put(`/uam/users/${id}`, data)
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/uam/users/${id}`)
  },

  setPassword: async (id: string, password: string): Promise<{ message: string }> => {
    const response = await api.post(`/uam/users/${id}/password`, { password })
    return response.data
  },
}

// Dashboard API
export const dashboardApi = {
  get: async (): Promise<DashboardResponse> => {
    const response = await api.get('/dashboard')
    return response.data
  },
}

// Dashboard Config Types - Re-export from types/index.ts
import type {
  WidgetPosition,
  WidgetSize,
  WidgetConfig,
  WidgetDefinition,
  WidgetType,
} from '@/types'

export type { WidgetPosition, WidgetSize, WidgetConfig, WidgetDefinition, WidgetType }

export interface DashboardConfigResponse {
  config_id: string
  user_id: string
  tenant_id: string
  widgets: WidgetConfig[]
  created_at: string
  updated_at: string
}

export interface SaveDashboardConfigRequest {
  widgets: WidgetConfig[]
}

export interface WidgetDataResponse<T = unknown> {
  widget_type: string
  data: T
}

// Dashboard Config API
export const dashboardConfigApi = {
  // Get user's dashboard configuration
  getConfig: async (): Promise<DashboardConfigResponse> => {
    const response = await api.get('/dashboard/config')
    return response.data
  },

  // Save user's dashboard configuration
  saveConfig: async (config: SaveDashboardConfigRequest): Promise<DashboardConfigResponse> => {
    const response = await api.put('/dashboard/config', config)
    return response.data
  },

  // Reset dashboard to default configuration
  resetConfig: async (): Promise<DashboardConfigResponse> => {
    const response = await api.post('/dashboard/config/reset')
    return response.data
  },

  // Get available widget definitions
  getAvailableWidgets: async (): Promise<WidgetDefinition[]> => {
    const response = await api.get('/dashboard/widgets')
    return response.data
  },

  // Get data for a specific widget
  getWidgetData: async <T>(widgetType: string): Promise<WidgetDataResponse<T>> => {
    const response = await api.get(`/dashboard/widgets/${widgetType}/data`)
    return response.data
  },

  // Get data for multiple widgets at once
  getMultipleWidgetData: async (widgetTypes: string[]): Promise<Record<string, WidgetDataResponse>> => {
    const response = await api.post('/dashboard/widgets/data', { widget_types: widgetTypes })
    return response.data
  },
}

// Chatbot Types
export type ChatMessageRole = 'user' | 'assistant' | 'system'

export type ChatIntentType =
  | 'create_invoice'
  | 'create_quote'
  | 'list_clients'
  | 'list_invoices'
  | 'list_quotes'
  | 'get_invoice_status'
  | 'get_quote_status'
  | 'faq'
  | 'help'
  | 'unknown'

export interface ChatAction {
  type: ChatIntentType
  description: string
  requires_confirmation?: boolean
  confirmation_data?: any
}

export interface ChatMessage {
  message_id: string
  role: ChatMessageRole
  content: string
  timestamp: string
  action?: ChatAction
  action_data?: any
}

export interface ChatRequest {
  message: string
  session_id?: string
  context?: ChatMessage[]
  confirm_action?: boolean
}

export interface ChatResponse {
  session_id: string
  message: ChatMessage
  context?: ChatMessage[]
}

export interface FAQItem {
  question: string
  answer: string
  keywords: string[]
}

// Chatbot API
export const chatbotApi = {
  chat: async (data: ChatRequest): Promise<ChatResponse> => {
    const response = await api.post('/chatbot/chat', data)
    return response.data
  },

  getFAQs: async (): Promise<{ faqs: FAQItem[] }> => {
    const response = await api.get('/chatbot/faqs')
    return response.data
  },
}

// Expense Filters
export interface ExpenseFilters {
  active_only?: boolean
  category_id?: string
  user_id?: string
  date_from?: string
  date_to?: string
}

// Expenses API
export const expensesApi = {
  getAll: async (filters?: ExpenseFilters): Promise<ExpenseListItem[]> => {
    const params: Record<string, string> = {}
    if (filters?.active_only) params.active_only = 'true'
    if (filters?.category_id) params.category_id = filters.category_id
    if (filters?.user_id) params.user_id = filters.user_id
    if (filters?.date_from) params.date_from = filters.date_from
    if (filters?.date_to) params.date_to = filters.date_to
    const response = await api.get('/billing/expenses', { params })
    return response.data
  },

  getById: async (id: string): Promise<Expense> => {
    const response = await api.get(`/billing/expenses/${id}`)
    return response.data
  },

  create: async (data: CreateExpenseRequest): Promise<Expense> => {
    const response = await api.post('/billing/expenses', data)
    return response.data
  },

  update: async (id: string, data: UpdateExpenseRequest): Promise<Expense> => {
    const response = await api.put(`/billing/expenses/${id}`, data)
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/billing/expenses/${id}`)
  },
}

// ==================== Project Management API ====================

// Projects API
export const projectsApi = {
  getAll: async (): Promise<Project[]> => {
    const response = await api.get('/projects')
    return response.data
  },

  getById: async (id: string): Promise<Project> => {
    const response = await api.get(`/projects/${id}`)
    return response.data
  },

  create: async (data: CreateProjectRequest): Promise<Project> => {
    const response = await api.post('/projects', data)
    return response.data
  },

  update: async (id: string, data: UpdateProjectRequest): Promise<Project> => {
    const response = await api.put(`/projects/${id}`, data)
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/projects/${id}`)
  },

  // Boards under project
  getBoards: async (projectId: string): Promise<Board[]> => {
    const response = await api.get(`/projects/${projectId}/boards`)
    return response.data
  },

  createBoard: async (projectId: string, data: CreateBoardRequest): Promise<Board> => {
    const response = await api.post(`/projects/${projectId}/boards`, data)
    return response.data
  },

  // Project members
  getMembers: async (projectId: string): Promise<ProjectMember[]> => {
    const response = await api.get(`/projects/${projectId}/members`)
    return response.data
  },

  addMember: async (projectId: string, data: AddProjectMemberRequest): Promise<ProjectMember> => {
    const response = await api.post(`/projects/${projectId}/members`, data)
    return response.data
  },

  updateMember: async (projectId: string, userId: string, data: UpdateProjectMemberRequest): Promise<ProjectMember> => {
    const response = await api.put(`/projects/${projectId}/members/${userId}`, data)
    return response.data
  },

  removeMember: async (projectId: string, userId: string): Promise<void> => {
    await api.delete(`/projects/${projectId}/members/${userId}`)
  },
}

// Boards API
export const boardsApi = {
  getById: async (id: string): Promise<BoardWithLists> => {
    const response = await api.get(`/boards/${id}`)
    return response.data
  },

  update: async (id: string, data: UpdateBoardRequest): Promise<BoardWithLists> => {
    const response = await api.put(`/boards/${id}`, data)
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/boards/${id}`)
  },

  // Lists under board
  createList: async (boardId: string, data: CreateBoardListRequest): Promise<BoardList> => {
    const response = await api.post(`/boards/${boardId}/lists`, data)
    return response.data
  },

  reorderLists: async (boardId: string, data: ReorderListsRequest): Promise<void> => {
    await api.put(`/boards/${boardId}/lists/reorder`, data)
  },

  // Labels under board
  createLabel: async (boardId: string, data: CreateBoardLabelRequest): Promise<BoardLabel> => {
    const response = await api.post(`/boards/${boardId}/labels`, data)
    return response.data
  },

  // Board members
  getMembers: async (boardId: string): Promise<BoardMember[]> => {
    const response = await api.get(`/boards/${boardId}/members`)
    return response.data
  },

  addMember: async (boardId: string, data: AddBoardMemberRequest): Promise<BoardMember> => {
    const response = await api.post(`/boards/${boardId}/members`, data)
    return response.data
  },

  updateMember: async (boardId: string, userId: string, data: UpdateBoardMemberRequest): Promise<BoardMember> => {
    const response = await api.put(`/boards/${boardId}/members/${userId}`, data)
    return response.data
  },

  removeMember: async (boardId: string, userId: string): Promise<void> => {
    await api.delete(`/boards/${boardId}/members/${userId}`)
  },

  // Board dependencies (for Gantt chart)
  getDependencies: async (boardId: string): Promise<CardDependency[]> => {
    const response = await api.get(`/boards/${boardId}/dependencies`)
    return response.data
  },

  // Archived cards
  getArchivedCards: async (boardId: string): Promise<BoardCard[]> => {
    const response = await api.get(`/boards/${boardId}/archived-cards`)
    return response.data
  },
}

// Lists API
export const listsApi = {
  update: async (listId: string, data: UpdateBoardListRequest): Promise<BoardList> => {
    const response = await api.put(`/lists/${listId}`, data)
    return response.data
  },

  delete: async (listId: string): Promise<void> => {
    await api.delete(`/lists/${listId}`)
  },

  // Cards under list
  createCard: async (listId: string, data: CreateBoardCardRequest): Promise<BoardCard> => {
    const response = await api.post(`/lists/${listId}/cards`, data)
    return response.data
  },

  reorderCards: async (listId: string, data: ReorderCardsRequest): Promise<void> => {
    await api.put(`/lists/${listId}/cards/reorder`, data)
  },
}

// Cards API
export const cardsApi = {
  getById: async (cardId: string): Promise<BoardCard> => {
    const response = await api.get(`/cards/${cardId}`)
    return response.data
  },

  update: async (cardId: string, data: UpdateBoardCardRequest): Promise<BoardCard> => {
    const response = await api.put(`/cards/${cardId}`, data)
    return response.data
  },

  delete: async (cardId: string): Promise<void> => {
    await api.delete(`/cards/${cardId}`)
  },

  move: async (cardId: string, data: MoveCardRequest): Promise<void> => {
    await api.post(`/cards/${cardId}/move`, data)
  },

  // Checklists
  createChecklist: async (cardId: string, data: CreateChecklistRequest): Promise<CardChecklist> => {
    const response = await api.post(`/cards/${cardId}/checklists`, data)
    return response.data
  },

  // Comments
  getComments: async (cardId: string): Promise<CardComment[]> => {
    const response = await api.get(`/cards/${cardId}/comments`)
    return response.data
  },

  createComment: async (cardId: string, data: CreateCommentRequest): Promise<CardComment> => {
    const response = await api.post(`/cards/${cardId}/comments`, data)
    return response.data
  },

  // Members
  addMember: async (cardId: string, userId: string): Promise<void> => {
    await api.post(`/cards/${cardId}/members`, { user_id: userId })
  },

  removeMember: async (cardId: string, userId: string): Promise<void> => {
    await api.delete(`/cards/${cardId}/members/${userId}`)
  },

  // Dependencies
  getDependencies: async (cardId: string): Promise<CardDependency[]> => {
    const response = await api.get(`/cards/${cardId}/dependencies`)
    return response.data
  },

  addDependency: async (cardId: string, data: CreateDependencyRequest): Promise<CardDependency> => {
    const response = await api.post(`/cards/${cardId}/dependencies`, data)
    return response.data
  },

  removeDependency: async (dependencyId: string): Promise<void> => {
    await api.delete(`/dependencies/${dependencyId}`)
  },

  // Labels
  addLabel: async (cardId: string, labelId: string): Promise<void> => {
    await api.post(`/cards/${cardId}/labels`, { label_id: labelId })
  },

  removeLabel: async (cardId: string, labelId: string): Promise<void> => {
    await api.delete(`/cards/${cardId}/labels/${labelId}`)
  },

  // Archive
  archive: async (cardId: string): Promise<void> => {
    await api.post(`/cards/${cardId}/archive`)
  },

  unarchive: async (cardId: string): Promise<void> => {
    await api.post(`/cards/${cardId}/unarchive`)
  },
}

// Labels API
export const labelsApi = {
  update: async (labelId: string, data: UpdateBoardLabelRequest): Promise<BoardLabel> => {
    const response = await api.put(`/labels/${labelId}`, data)
    return response.data
  },

  delete: async (labelId: string): Promise<void> => {
    await api.delete(`/labels/${labelId}`)
  },
}

// Checklists API
export const checklistsApi = {
  delete: async (checklistId: string): Promise<void> => {
    await api.delete(`/checklists/${checklistId}`)
  },

  createItem: async (checklistId: string, data: CreateChecklistItemRequest): Promise<ChecklistItem> => {
    const response = await api.post(`/checklists/${checklistId}/items`, data)
    return response.data
  },
}

// Checklist Items API
export const checklistItemsApi = {
  update: async (itemId: string, data: UpdateChecklistItemRequest): Promise<ChecklistItem> => {
    const response = await api.put(`/checklist-items/${itemId}`, data)
    return response.data
  },

  delete: async (itemId: string): Promise<void> => {
    await api.delete(`/checklist-items/${itemId}`)
  },
}

// Comments API
export const commentsApi = {
  delete: async (commentId: string): Promise<void> => {
    await api.delete(`/comments/${commentId}`)
  },
}

// Attachments API
export interface CardAttachment {
  attachment_id: string
  card_id: string
  tenant_id: string
  file_name: string
  file_url: string
  file_type: string
  file_size: number
  created_at: string
  is_active: boolean
}

export const attachmentsApi = {
  list: async (cardId: string): Promise<CardAttachment[]> => {
    const response = await api.get(`/cards/${cardId}/attachments`)
    return response.data
  },

  upload: async (cardId: string, file: File): Promise<CardAttachment> => {
    const formData = new FormData()
    formData.append('file', file)
    const response = await api.post(`/cards/${cardId}/attachments`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  },

  delete: async (cardId: string, attachmentId: string): Promise<void> => {
    await api.delete(`/cards/${cardId}/attachments/${attachmentId}`)
  },
}

// ============================================
// Tenant/Agency Management API (Super Admin)
// ============================================
export const tenantsApi = {
  getAll: async (): Promise<TenantWithStats[]> => {
    const response = await api.get('/admin/tenants')
    // Response is already unwrapped by interceptor, so data is { tenants: [...] }
    return response.data?.tenants || []
  },

  getById: async (id: string): Promise<TenantWithStats> => {
    const response = await api.get(`/admin/tenants/${id}`)
    return response.data?.tenant || response.data
  },

  create: async (data: CreateTenantRequest): Promise<CreateTenantResponse> => {
    const response = await api.post('/admin/tenants', data)
    return response.data
  },

  update: async (id: string, data: UpdateTenantRequest): Promise<TenantWithStats> => {
    const response = await api.put(`/admin/tenants/${id}`, data)
    return response.data?.tenant || response.data
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/admin/tenants/${id}`)
  },

  updateTier: async (id: string, data: UpdateTierRequest): Promise<TenantWithStats> => {
    const response = await api.put(`/admin/tenants/${id}/tier`, data)
    return response.data?.tenant || response.data
  },

  reactivate: async (id: string, data: ReactivateTenantRequest): Promise<TenantWithStats> => {
    const response = await api.put(`/admin/tenants/${id}/reactivate`, data)
    return response.data?.tenant || response.data
  },

  getSubscriptionHistory: async (id: string): Promise<SubscriptionHistory[]> => {
    const response = await api.get(`/admin/tenants/${id}/subscription-history`)
    return response.data?.history || []
  },
}

// ============================================================================
// Support Tickets API
// ============================================================================

export const supportTicketsApi = {
  // User endpoints
  create: async (data: CreateTicketRequest): Promise<SupportTicket> => {
    const response = await api.post('/support/tickets', data)
    return response.data
  },

  getMyTickets: async (filters?: TicketListFilters): Promise<SupportTicket[]> => {
    const params = new URLSearchParams()
    if (filters?.ticket_type) params.append('ticket_type', filters.ticket_type)
    if (filters?.status) params.append('status', filters.status)
    if (filters?.priority) params.append('priority', filters.priority)
    const response = await api.get(`/support/tickets?${params.toString()}`)
    return response.data || []
  },

  getById: async (id: string): Promise<SupportTicket> => {
    const response = await api.get(`/support/tickets/${id}`)
    return response.data
  },

  update: async (id: string, data: UpdateTicketRequest): Promise<SupportTicket> => {
    const response = await api.put(`/support/tickets/${id}`, data)
    return response.data
  },

  // Admin endpoints
  getAllTickets: async (filters?: TicketListFilters): Promise<SupportTicketWithUser[]> => {
    const params = new URLSearchParams()
    if (filters?.ticket_type) params.append('ticket_type', filters.ticket_type)
    if (filters?.status) params.append('status', filters.status)
    if (filters?.priority) params.append('priority', filters.priority)
    const response = await api.get(`/admin/support/tickets?${params.toString()}`)
    return response.data || []
  },

  getTicketById: async (id: string): Promise<SupportTicketWithUser> => {
    const response = await api.get(`/admin/support/tickets/${id}`)
    return response.data
  },

  updateStatus: async (id: string, data: UpdateTicketStatusRequest): Promise<SupportTicket> => {
    const response = await api.put(`/admin/support/tickets/${id}/status`, data)
    return response.data
  },

  // Attachment endpoints
  listAttachments: async (ticketId: string): Promise<TicketAttachment[]> => {
    const response = await api.get(`/support/tickets/${ticketId}/attachments`)
    return response.data || []
  },

  uploadAttachment: async (ticketId: string, file: File): Promise<TicketAttachment> => {
    const formData = new FormData()
    formData.append('file', file)
    const response = await api.post(`/support/tickets/${ticketId}/attachments`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  },

  deleteAttachment: async (ticketId: string, attachmentId: string): Promise<void> => {
    await api.delete(`/support/tickets/${ticketId}/attachments/${attachmentId}`)
  },

  // Comment endpoints (user - for their own tickets)
  listComments: async (ticketId: string): Promise<TicketComment[]> => {
    const response = await api.get(`/support/tickets/${ticketId}/comments`)
    return response.data || []
  },

  createComment: async (ticketId: string, data: CreateTicketCommentRequest): Promise<TicketComment> => {
    const response = await api.post(`/support/tickets/${ticketId}/comments`, data)
    return response.data
  },

  // Admin comment endpoints
  listCommentsAdmin: async (ticketId: string): Promise<TicketComment[]> => {
    const response = await api.get(`/admin/support/tickets/${ticketId}/comments`)
    return response.data || []
  },

  createCommentAdmin: async (ticketId: string, data: CreateTicketCommentRequest): Promise<TicketComment> => {
    const response = await api.post(`/admin/support/tickets/${ticketId}/comments`, data)
    return response.data
  },

  deleteCommentAdmin: async (commentId: string): Promise<void> => {
    await api.delete(`/admin/support/comments/${commentId}`)
  },
}

// Audit Logs API
export const auditLogsApi = {
  getAll: async (filters?: AuditLogFilters): Promise<AuditLogPage> => {
    const params: Record<string, any> = {}
    if (filters) {
      if (filters.entity_type) params.entity_type = filters.entity_type
      if (filters.entity_id) params.entity_id = filters.entity_id
      if (filters.action) params.action = filters.action
      if (filters.user_id) params.user_id = filters.user_id
      if (filters.start_date) params.start_date = filters.start_date
      if (filters.end_date) params.end_date = filters.end_date
      if (filters.search) params.search = filters.search
      if (filters.page) params.page = filters.page
      if (filters.page_size) params.page_size = filters.page_size
    }
    const response = await api.get('/audit-logs', { params })
    return response.data
  },

  getByEntity: async (entityType: string, entityId: string): Promise<AuditLog[]> => {
    const response = await api.get(`/audit-logs/entity/${entityType}/${entityId}`)
    // Handle both wrapped { data: [...] } and direct array responses
    const data = response.data
    if (Array.isArray(data)) {
      return data
    }
    return data?.data || []
  },
}

// Time Tracking API
export const timeTrackingApi = {
  // CRUD operations
  create: async (data: CreateTimeEntryRequest): Promise<TimeEntry> => {
    const response = await api.post('/time-entries', data)
    return response.data
  },

  getById: async (entryId: string): Promise<TimeEntry> => {
    const response = await api.get(`/time-entries/${entryId}`)
    return response.data
  },

  update: async (entryId: string, data: UpdateTimeEntryRequest): Promise<TimeEntry> => {
    const response = await api.put(`/time-entries/${entryId}`, data)
    return response.data
  },

  delete: async (entryId: string): Promise<void> => {
    await api.delete(`/time-entries/${entryId}`)
  },

  list: async (filters?: TimeEntryFilters): Promise<TimeEntry[]> => {
    const params: Record<string, any> = {}
    if (filters) {
      if (filters.user_id) params.user_id = filters.user_id
      if (filters.project_id) params.project_id = filters.project_id
      if (filters.card_id) params.card_id = filters.card_id
      if (filters.start_date) params.start_date = filters.start_date
      if (filters.end_date) params.end_date = filters.end_date
      if (filters.is_running !== undefined) params.is_running = filters.is_running
    }
    const response = await api.get('/time-entries', { params })
    return response.data || []
  },

  // Calendar view
  getCalendarEntries: async (startDate: string, endDate: string): Promise<TimeEntry[]> => {
    const response = await api.get('/time-entries/calendar', {
      params: { start_date: startDate, end_date: endDate }
    })
    return response.data || []
  },

  // Timer operations
  startTimer: async (data: StartTimerRequest): Promise<TimeEntry> => {
    const response = await api.post('/time-entries/timer/start', data)
    return response.data
  },

  stopTimer: async (data?: StopTimerRequest): Promise<TimeEntry> => {
    const response = await api.post('/time-entries/timer/stop', data || {})
    return response.data
  },

  getActiveTimer: async (): Promise<TimeEntry | null> => {
    const response = await api.get('/time-entries/timer/active')
    return response.data
  },

  // Reports
  getReportSummary: async (filters: TimeReportFilters): Promise<TimeReportSummary> => {
    const response = await api.get('/time-entries/reports/summary', { params: filters })
    return response.data
  },

  getDailyReport: async (filters: TimeReportFilters): Promise<DailySummary[]> => {
    const response = await api.get('/time-entries/reports/daily', { params: filters })
    return response.data || []
  },

  getProjectReport: async (filters: TimeReportFilters): Promise<ProjectSummary[]> => {
    const response = await api.get('/time-entries/reports/by-project', { params: filters })
    return response.data || []
  },

  getUserReport: async (filters: TimeReportFilters): Promise<UserSummary[]> => {
    const response = await api.get('/time-entries/reports/by-user', { params: filters })
    return response.data || []
  },
}

// ============================================================================
// CRM API
// ============================================================================

export const crmApi = {
  // Lead Sources
  getLeadSources: async (activeOnly = false): Promise<LeadSource[]> => {
    const response = await api.get('/crm/lead-sources', { params: { active_only: activeOnly } })
    return response.data || []
  },

  getLeadSource: async (sourceId: string): Promise<LeadSource> => {
    const response = await api.get(`/crm/lead-sources/${sourceId}`)
    return response.data
  },

  createLeadSource: async (data: CreateLeadSourceRequest): Promise<LeadSource> => {
    const response = await api.post('/crm/lead-sources', data)
    return response.data
  },

  updateLeadSource: async (sourceId: string, data: UpdateLeadSourceRequest): Promise<LeadSource> => {
    const response = await api.put(`/crm/lead-sources/${sourceId}`, data)
    return response.data
  },

  deleteLeadSource: async (sourceId: string): Promise<void> => {
    await api.delete(`/crm/lead-sources/${sourceId}`)
  },

  // Lead Statuses
  getLeadStatuses: async (activeOnly = false): Promise<LeadStatus[]> => {
    const response = await api.get('/crm/lead-statuses', { params: { active_only: activeOnly } })
    return response.data || []
  },

  getLeadStatus: async (statusId: string): Promise<LeadStatus> => {
    const response = await api.get(`/crm/lead-statuses/${statusId}`)
    return response.data
  },

  createLeadStatus: async (data: CreateLeadStatusRequest): Promise<LeadStatus> => {
    const response = await api.post('/crm/lead-statuses', data)
    return response.data
  },

  updateLeadStatus: async (statusId: string, data: UpdateLeadStatusRequest): Promise<LeadStatus> => {
    const response = await api.put(`/crm/lead-statuses/${statusId}`, data)
    return response.data
  },

  deleteLeadStatus: async (statusId: string): Promise<void> => {
    await api.delete(`/crm/lead-statuses/${statusId}`)
  },

  reorderLeadStatuses: async (data: ReorderLeadStatusesRequest): Promise<void> => {
    await api.post('/crm/lead-statuses/reorder', data)
  },

  // Lead Tags
  getLeadTags: async (activeOnly = false): Promise<LeadTag[]> => {
    const response = await api.get('/crm/lead-tags', { params: { active_only: activeOnly } })
    return response.data || []
  },

  getLeadTag: async (tagId: string): Promise<LeadTag> => {
    const response = await api.get(`/crm/lead-tags/${tagId}`)
    return response.data
  },

  createLeadTag: async (data: CreateLeadTagRequest): Promise<LeadTag> => {
    const response = await api.post('/crm/lead-tags', data)
    return response.data
  },

  updateLeadTag: async (tagId: string, data: UpdateLeadTagRequest): Promise<LeadTag> => {
    const response = await api.put(`/crm/lead-tags/${tagId}`, data)
    return response.data
  },

  deleteLeadTag: async (tagId: string): Promise<void> => {
    await api.delete(`/crm/lead-tags/${tagId}`)
  },

  // Leads
  getLeads: async (filters?: LeadListFilters): Promise<LeadListResponse> => {
    const response = await api.get('/crm/leads', { params: filters })
    return response.data || { leads: [], total: 0, page: 1, page_size: 10, total_pages: 0 }
  },

  getLead: async (leadId: string): Promise<Lead> => {
    const response = await api.get(`/crm/leads/${leadId}`)
    return response.data
  },

  createLead: async (data: CreateLeadRequest): Promise<Lead> => {
    const response = await api.post('/crm/leads', data)
    return response.data
  },

  updateLead: async (leadId: string, data: UpdateLeadRequest): Promise<Lead> => {
    const response = await api.put(`/crm/leads/${leadId}`, data)
    return response.data
  },

  deleteLead: async (leadId: string): Promise<void> => {
    await api.delete(`/crm/leads/${leadId}`)
  },

  assignLead: async (leadId: string, data: AssignLeadRequest): Promise<Lead> => {
    const response = await api.post(`/crm/leads/${leadId}/assign`, data)
    return response.data
  },

  convertLead: async (leadId: string, data: ConvertLeadRequest): Promise<Lead> => {
    const response = await api.post(`/crm/leads/${leadId}/convert`, data)
    return response.data
  },
}

// Pipeline API
export const pipelineApi = {
  // Pipelines
  getPipelines: async (activeOnly = false): Promise<Pipeline[]> => {
    const response = await api.get('/crm/pipelines', { params: { active_only: String(activeOnly) } })
    return response.data || []
  },

  getPipeline: async (pipelineId: string): Promise<Pipeline> => {
    const response = await api.get(`/crm/pipelines/${pipelineId}`)
    return response.data
  },

  createPipeline: async (data: CreatePipelineRequest): Promise<Pipeline> => {
    const response = await api.post('/crm/pipelines', data)
    return response.data
  },

  updatePipeline: async (pipelineId: string, data: UpdatePipelineRequest): Promise<Pipeline> => {
    const response = await api.put(`/crm/pipelines/${pipelineId}`, data)
    return response.data
  },

  deletePipeline: async (pipelineId: string): Promise<void> => {
    await api.delete(`/crm/pipelines/${pipelineId}`)
  },

  setDefaultPipeline: async (pipelineId: string): Promise<Pipeline> => {
    const response = await api.post(`/crm/pipelines/${pipelineId}/set-default`)
    return response.data
  },

  // Pipeline Stages
  getStages: async (pipelineId: string, activeOnly = false): Promise<PipelineStage[]> => {
    const response = await api.get(`/crm/pipelines/${pipelineId}/stages`, { params: { active_only: activeOnly } })
    return response.data || []
  },

  getStage: async (pipelineId: string, stageId: string): Promise<PipelineStage> => {
    const response = await api.get(`/crm/pipelines/${pipelineId}/stages/${stageId}`)
    return response.data
  },

  createStage: async (pipelineId: string, data: CreatePipelineStageRequest): Promise<PipelineStage> => {
    const response = await api.post(`/crm/pipelines/${pipelineId}/stages`, data)
    return response.data
  },

  updateStage: async (pipelineId: string, stageId: string, data: UpdatePipelineStageRequest): Promise<PipelineStage> => {
    const response = await api.put(`/crm/pipelines/${pipelineId}/stages/${stageId}`, data)
    return response.data
  },

  deleteStage: async (pipelineId: string, stageId: string): Promise<void> => {
    await api.delete(`/crm/pipelines/${pipelineId}/stages/${stageId}`)
  },

  reorderStages: async (pipelineId: string, data: ReorderPipelineStagesRequest): Promise<void> => {
    await api.post(`/crm/pipelines/${pipelineId}/stages/reorder`, data)
  },
}

// Deal API
export const dealApi = {
  getDeals: async (filters?: DealListFilters): Promise<DealListResponse> => {
    const response = await api.get('/crm/deals', { params: filters })
    return response.data || { deals: [], total: 0, page: 1, page_size: 10, total_pages: 0 }
  },

  getDeal: async (dealId: string): Promise<Deal> => {
    const response = await api.get(`/crm/deals/${dealId}`)
    return response.data
  },

  createDeal: async (data: CreateDealRequest): Promise<Deal> => {
    const response = await api.post('/crm/deals', data)
    return response.data
  },

  updateDeal: async (dealId: string, data: UpdateDealRequest): Promise<Deal> => {
    const response = await api.put(`/crm/deals/${dealId}`, data)
    return response.data
  },

  deleteDeal: async (dealId: string): Promise<void> => {
    await api.delete(`/crm/deals/${dealId}`)
  },

  moveDeal: async (dealId: string, data: MoveDealRequest): Promise<Deal> => {
    const response = await api.put(`/crm/deals/${dealId}/move`, data)
    return response.data
  },

  markWon: async (dealId: string, data?: WonDealRequest): Promise<Deal> => {
    const response = await api.post(`/crm/deals/${dealId}/won`, data || {})
    return response.data
  },

  markLost: async (dealId: string, data?: LostDealRequest): Promise<Deal> => {
    const response = await api.post(`/crm/deals/${dealId}/lost`, data || {})
    return response.data
  },

  assignDeal: async (dealId: string, data: AssignDealRequest): Promise<Deal> => {
    const response = await api.post(`/crm/deals/${dealId}/assign`, data)
    return response.data
  },

  updatePositions: async (data: UpdateDealPositionsRequest): Promise<void> => {
    await api.post('/crm/deals/positions', data)
  },

  // Kanban Board
  getKanbanBoard: async (filters?: KanbanBoardFilters): Promise<KanbanBoardResponse> => {
    const response = await api.get('/crm/deals/kanban', { params: filters })
    return response.data
  },
}

// Activity API
export const activityApi = {
  getActivities: async (filters?: ActivityListFilters): Promise<ActivityListResponse> => {
    const response = await api.get('/crm/activities', { params: filters })
    return response.data || { activities: [], total: 0, page: 1, page_size: 20, total_pages: 0 }
  },

  getActivity: async (activityId: string): Promise<Activity> => {
    const response = await api.get(`/crm/activities/${activityId}`)
    return response.data
  },

  createActivity: async (data: CreateActivityRequest): Promise<Activity> => {
    const response = await api.post('/crm/activities', data)
    return response.data
  },

  updateActivity: async (activityId: string, data: UpdateActivityRequest): Promise<Activity> => {
    const response = await api.put(`/crm/activities/${activityId}`, data)
    return response.data
  },

  deleteActivity: async (activityId: string): Promise<void> => {
    await api.delete(`/crm/activities/${activityId}`)
  },

  // Timeline
  getTimeline: async (entityType: CRMEntityType, entityId: string): Promise<TimelineResponse> => {
    const response = await api.get(`/crm/activities/timeline/${entityType}/${entityId}`)
    return response.data
  },

  // Tasks
  getTasks: async (filters?: ActivityListFilters): Promise<ActivityListResponse> => {
    const response = await api.get('/crm/activities/tasks', { params: filters })
    return response.data || { activities: [], total: 0, page: 1, page_size: 20, total_pages: 0 }
  },

  getOverdueTasks: async (): Promise<Activity[]> => {
    const response = await api.get('/crm/activities/tasks/overdue')
    return response.data || []
  },

  getTasksDueToday: async (): Promise<Activity[]> => {
    const response = await api.get('/crm/activities/tasks/due-today')
    return response.data || []
  },

  getTaskSummary: async (): Promise<TaskSummary> => {
    const response = await api.get('/crm/activities/tasks/summary')
    return response.data
  },

  completeTask: async (activityId: string): Promise<Activity> => {
    const response = await api.post(`/crm/activities/${activityId}/complete`)
    return response.data
  },

  reopenTask: async (activityId: string): Promise<Activity> => {
    const response = await api.post(`/crm/activities/${activityId}/reopen`)
    return response.data
  },
}

// Reminder API
export const reminderApi = {
  getReminders: async (filters?: ReminderListFilters): Promise<ReminderListResponse> => {
    const response = await api.get('/crm/reminders', { params: filters })
    return response.data || { reminders: [], total: 0, page: 1, page_size: 20, total_pages: 0 }
  },

  getReminder: async (reminderId: string): Promise<Reminder> => {
    const response = await api.get(`/crm/reminders/${reminderId}`)
    return response.data
  },

  createReminder: async (data: CreateReminderRequest): Promise<Reminder> => {
    const response = await api.post('/crm/reminders', data)
    return response.data
  },

  updateReminder: async (reminderId: string, data: UpdateReminderRequest): Promise<Reminder> => {
    const response = await api.put(`/crm/reminders/${reminderId}`, data)
    return response.data
  },

  deleteReminder: async (reminderId: string): Promise<void> => {
    await api.delete(`/crm/reminders/${reminderId}`)
  },

  completeReminder: async (reminderId: string): Promise<Reminder> => {
    const response = await api.post(`/crm/reminders/${reminderId}/complete`)
    return response.data
  },

  dismissReminder: async (reminderId: string): Promise<Reminder> => {
    const response = await api.post(`/crm/reminders/${reminderId}/dismiss`)
    return response.data
  },

  snoozeReminder: async (reminderId: string, data: SnoozeReminderRequest): Promise<Reminder> => {
    const response = await api.post(`/crm/reminders/${reminderId}/snooze`, data)
    return response.data
  },

  getUpcomingReminders: async (limit?: number): Promise<UpcomingRemindersResponse> => {
    const response = await api.get('/crm/reminders/upcoming', { params: { limit } })
    return response.data || { reminders: [], total: 0 }
  },
}

// Automation API
export const automationApi = {
  getAutomations: async (filters?: AutomationListFilters): Promise<AutomationListResponse> => {
    const response = await api.get('/crm/automations/rules', { params: filters })
    return response.data || { rules: [], total: 0, page: 1, page_size: 25, total_pages: 0 }
  },

  getAutomation: async (ruleId: string): Promise<AutomationRule> => {
    const response = await api.get(`/crm/automations/rules/${ruleId}`)
    return response.data
  },

  createAutomation: async (data: CreateAutomationRequest): Promise<AutomationRule> => {
    const response = await api.post('/crm/automations/rules', data)
    return response.data
  },

  updateAutomation: async (ruleId: string, data: UpdateAutomationRequest): Promise<AutomationRule> => {
    const response = await api.put(`/crm/automations/rules/${ruleId}`, data)
    return response.data
  },

  deleteAutomation: async (ruleId: string): Promise<void> => {
    await api.delete(`/crm/automations/rules/${ruleId}`)
  },

  toggleAutomation: async (ruleId: string, isActive: boolean): Promise<AutomationRule> => {
    const response = await api.patch(`/crm/automations/rules/${ruleId}/toggle`, { is_enabled: isActive })
    return response.data
  },

  getAutomationLogs: async (filters?: AutomationLogListFilters): Promise<AutomationLogListResponse> => {
    const response = await api.get('/crm/automations/logs', { params: filters })
    return response.data || { logs: [], total: 0, page: 1, page_size: 25, total_pages: 0 }
  },
}

// CRM Dashboard API
export const crmDashboardApi = {
  // Lead Funnel
  getLeadFunnel: async (filters?: CRMDashboardRequest): Promise<LeadFunnelResponse> => {
    const response = await api.get('/crm/dashboard/lead-funnel', { params: filters })
    return response.data
  },

  // Pipeline Overview
  getPipelineOverview: async (filters?: CRMDashboardRequest): Promise<PipelineOverviewResponse> => {
    const response = await api.get('/crm/dashboard/pipeline-overview', { params: filters })
    return response.data
  },

  // Activity Summary
  getActivitySummary: async (filters?: CRMDashboardRequest): Promise<ActivitySummaryResponse> => {
    const response = await api.get('/crm/dashboard/activity-summary', { params: filters })
    return response.data
  },

  // Sales Forecast
  getSalesForecast: async (filters?: CRMDashboardRequest & { months?: number }): Promise<SalesForecastResponse> => {
    const response = await api.get('/crm/dashboard/sales-forecast', { params: filters })
    return response.data
  },

  // Lead Source Stats
  getLeadSourceStats: async (filters?: CRMDashboardRequest): Promise<LeadSourceStatsResponse> => {
    const response = await api.get('/crm/dashboard/lead-sources', { params: filters })
    return response.data
  },

  // Deals by Owner
  getDealsByOwner: async (filters?: CRMDashboardRequest): Promise<DealsByOwnerResponse> => {
    const response = await api.get('/crm/dashboard/deals-by-owner', { params: filters })
    return response.data
  },
}

// CRM Reports API
export const crmReportsApi = {
  // Lead Report
  getLeadReport: async (filters?: CRMReportFilters): Promise<LeadReportResponse> => {
    const response = await api.get('/crm/reports/leads', { params: filters })
    return response.data
  },

  // Pipeline Report
  getPipelineReport: async (filters?: CRMReportFilters): Promise<PipelineReportResponse> => {
    const response = await api.get('/crm/reports/pipeline', { params: filters })
    return response.data
  },

  // Activity Report
  getActivityReport: async (filters?: CRMReportFilters): Promise<ActivityReportResponse> => {
    const response = await api.get('/crm/reports/activities', { params: filters })
    return response.data
  },

  // Conversion Report
  getConversionReport: async (filters?: CRMReportFilters): Promise<ConversionReportResponse> => {
    const response = await api.get('/crm/reports/conversions', { params: filters })
    return response.data
  },

  // Sales Report
  getSalesReport: async (filters?: CRMReportFilters): Promise<SalesReportResponse> => {
    const response = await api.get('/crm/reports/sales', { params: filters })
    return response.data
  },
}

// CRM Email API
export const crmEmailApi = {
  // Send email to lead
  sendLeadEmail: async (leadId: string, data: SendLeadEmailRequest): Promise<SendEmailResponse> => {
    const response = await api.post(`/crm/leads/${leadId}/email`, data)
    return response.data
  },

  // Send email for deal
  sendDealEmail: async (dealId: string, data: SendDealEmailRequest): Promise<SendEmailResponse> => {
    const response = await api.post(`/crm/deals/${dealId}/email`, data)
    return response.data
  },
}

// ============================================================================
// Contracts Management & E-signing API
// ============================================================================

// Contract Templates API
export const contractTemplatesApi = {
  getAll: async (activeOnly?: boolean): Promise<ContractTemplateListItem[]> => {
    const response = await api.get('/contracts/templates', { params: { active_only: activeOnly } })
    return response.data || []
  },

  getById: async (id: string): Promise<ContractTemplate> => {
    const response = await api.get(`/contracts/templates/${id}`)
    return response.data
  },

  create: async (data: CreateContractTemplateRequest): Promise<ContractTemplate> => {
    const response = await api.post('/contracts/templates', data)
    return response.data
  },

  update: async (id: string, data: UpdateContractTemplateRequest): Promise<ContractTemplate> => {
    const response = await api.put(`/contracts/templates/${id}`, data)
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/contracts/templates/${id}`)
  },
}

// Contracts API
export const contractsApi = {
  getAll: async (filters?: ContractFilters): Promise<ContractListItem[]> => {
    const response = await api.get('/contracts', { params: filters })
    return response.data || []
  },

  getById: async (id: string): Promise<Contract> => {
    const response = await api.get(`/contracts/${id}`)
    return response.data
  },

  create: async (data: CreateContractRequest): Promise<Contract> => {
    const response = await api.post('/contracts', data)
    return response.data
  },

  update: async (id: string, data: UpdateContractRequest): Promise<Contract> => {
    const response = await api.put(`/contracts/${id}`, data)
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/contracts/${id}`)
  },

  // Signing workflow
  sendForSigning: async (id: string, data: SendForSigningRequest): Promise<Contract> => {
    const response = await api.post(`/contracts/${id}/send`, data)
    return response.data
  },

  addSigner: async (id: string, data: AddSignerRequest): Promise<ContractSigner> => {
    const response = await api.post(`/contracts/${id}/signers`, data)
    return response.data
  },

  removeSigner: async (contractId: string, signerId: string): Promise<void> => {
    await api.delete(`/contracts/${contractId}/signers/${signerId}`)
  },

  getSigningLink: async (contractId: string, signerId: string): Promise<SigningLinkResponse> => {
    const response = await api.get(`/contracts/${contractId}/signers/${signerId}/link`)
    return response.data
  },

  resendSigningLink: async (contractId: string, signerId: string): Promise<SigningLinkResponse> => {
    const response = await api.post(`/contracts/${contractId}/signers/${signerId}/resend`)
    return response.data
  },

  sendReminder: async (id: string, signerId?: string): Promise<void> => {
    await api.post(`/contracts/${id}/remind`, { signer_id: signerId })
  },

  cancel: async (id: string): Promise<Contract> => {
    const response = await api.post(`/contracts/${id}/cancel`)
    return response.data
  },

  // Versions
  getVersions: async (id: string): Promise<ContractVersion[]> => {
    const response = await api.get(`/contracts/${id}/versions`)
    return response.data
  },

  getVersion: async (contractId: string, versionId: string): Promise<ContractVersion> => {
    const response = await api.get(`/contracts/${contractId}/versions/${versionId}`)
    return response.data
  },

  // Audit log
  getAuditLog: async (id: string): Promise<ContractAuditLog[]> => {
    const response = await api.get(`/contracts/${id}/audit`)
    return response.data
  },

  // PDF
  downloadPdf: async (id: string, includeSignatures?: boolean): Promise<Blob> => {
    const response = await api.get(`/contracts/${id}/pdf`, {
      params: { include_signatures: includeSignatures },
      responseType: 'blob',
    })
    return response.data
  },
}

// Public Contract Signing API (no auth required)
export const publicSigningApi = {
  getContract: async (token: string): Promise<PublicContractView> => {
    const response = await axios.get(`${API_BASE_URL}/sign/${token}`)
    return response.data.data
  },

  sign: async (token: string, data: SignContractRequest): Promise<void> => {
    await axios.post(`${API_BASE_URL}/sign/${token}`, data)
  },

  decline: async (token: string, data: DeclineContractRequest): Promise<void> => {
    await axios.post(`${API_BASE_URL}/sign/${token}/decline`, data)
  },

  requestOTP: async (token: string): Promise<RequestOTPResponse> => {
    const response = await axios.post(`${API_BASE_URL}/sign/${token}/request-otp`)
    return response.data.data
  },

  verifyOTP: async (token: string, data: VerifyOTPRequest): Promise<VerifyOTPResponse> => {
    const response = await axios.post(`${API_BASE_URL}/sign/${token}/verify-otp`, data)
    return response.data.data
  },
}

// Scheduler API (Super Admin only)
export const schedulerApi = {
  getStatus: async (): Promise<SchedulerStatusResponse> => {
    const response = await api.get('/admin/scheduler/status')
    return response.data
  },

  listConfigs: async (): Promise<{ configs: SchedulerConfigListItem[] }> => {
    const response = await api.get('/admin/scheduler/configs')
    return response.data
  },

  getConfig: async (jobType: JobType): Promise<SchedulerConfig> => {
    const response = await api.get(`/admin/scheduler/configs/${jobType}`)
    return response.data
  },

  updateConfig: async (jobType: JobType, data: UpdateSchedulerConfigRequest): Promise<SchedulerConfig> => {
    const response = await api.put(`/admin/scheduler/configs/${jobType}`, data)
    return response.data
  },

  triggerJob: async (data: TriggerJobRequest): Promise<TriggerJobResponse> => {
    const response = await api.post('/admin/scheduler/trigger', data)
    return response.data
  },

  getHistory: async (params?: {
    job_type?: JobType
    status?: JobStatus
    limit?: number
    offset?: number
  }): Promise<ExecutionHistoryResponse> => {
    const response = await api.get('/admin/scheduler/history', { params })
    return response.data
  },
}

// ============================================================================
// Payment Gateway API
// ============================================================================

import type {
  PaymentGatewaySettings,
  CreatePaymentGatewaySettingsRequest,
  UpdatePaymentGatewaySettingsRequest,
  PaymentLink,
  CreatePaymentLinkRequest,
  OnlinePayment,
  PaymentListFilters,
  PaymentListResponse,
  PublicPaymentInfo,
  AvailableGateway,
} from '@/types'

// Payment Gateway Settings API
export const paymentGatewaysApi = {
  getAll: async (): Promise<PaymentGatewaySettings[]> => {
    const response = await api.get('/payments/gateways')
    return response.data || []
  },

  getById: async (settingsId: string): Promise<PaymentGatewaySettings> => {
    const response = await api.get(`/payments/gateways/${settingsId}`)
    return response.data
  },

  create: async (data: CreatePaymentGatewaySettingsRequest): Promise<PaymentGatewaySettings> => {
    const response = await api.post('/payments/gateways', data)
    return response.data
  },

  update: async (settingsId: string, data: UpdatePaymentGatewaySettingsRequest): Promise<PaymentGatewaySettings> => {
    const response = await api.put(`/payments/gateways/${settingsId}`, data)
    return response.data
  },

  delete: async (settingsId: string): Promise<void> => {
    await api.delete(`/payments/gateways/${settingsId}`)
  },
}

// Payment Links API
export const paymentLinksApi = {
  create: async (data: CreatePaymentLinkRequest): Promise<PaymentLink> => {
    const response = await api.post('/payments/links', data)
    return response.data
  },

  getById: async (linkId: string): Promise<PaymentLink> => {
    const response = await api.get(`/payments/links/${linkId}`)
    return response.data
  },

  getByInvoice: async (invoiceId: string): Promise<PaymentLink[]> => {
    const response = await api.get(`/payments/links/invoice/${invoiceId}`)
    return response.data || []
  },

  cancel: async (linkId: string): Promise<void> => {
    await api.delete(`/payments/links/${linkId}`)
  },
}

// Online Payments API
export const onlinePaymentsApi = {
  getAll: async (filters?: PaymentListFilters): Promise<PaymentListResponse> => {
    const response = await api.get('/payments', { params: filters })
    return response.data
  },

  getById: async (paymentId: string): Promise<OnlinePayment> => {
    const response = await api.get(`/payments/${paymentId}`)
    return response.data
  },
}

// Public Payment API (no auth required - uses axios directly)
export const publicPaymentApi = {
  getPaymentInfo: async (token: string): Promise<PublicPaymentInfo> => {
    const response = await axios.get(`/api/pay/${token}`)
    // Handle wrapped response
    if (response.data && 'success' in response.data && 'data' in response.data) {
      return response.data.data
    }
    return response.data
  },

  getAvailableGateways: async (token: string): Promise<AvailableGateway[]> => {
    const response = await axios.get(`/api/pay/${token}/gateways`)
    if (response.data && 'success' in response.data && 'data' in response.data) {
      return response.data.data.gateways || []
    }
    return response.data.gateways || []
  },

  initiateCheckout: async (token: string, gatewayType: string): Promise<{ checkout_url: string; session_id: string }> => {
    const response = await axios.post(`/api/pay/${token}/checkout`, { gateway_type: gatewayType })
    if (response.data && 'success' in response.data && 'data' in response.data) {
      return response.data.data
    }
    return response.data
  },

  getPaymentStatus: async (sessionId: string): Promise<{ status: string; message: string }> => {
    const response = await axios.get(`/api/pay/success`, { params: { session_id: sessionId } })
    if (response.data && 'success' in response.data && 'data' in response.data) {
      return response.data.data
    }
    return response.data
  },
}

// Health Check API (Super Admin only)
import type { SystemHealth, LogListResponse, LogContentResponse, LogFilters } from '@/types'

export const healthApi = {
  getSystemHealth: async (): Promise<SystemHealth> => {
    const response = await api.get('/admin/health')
    return response.data
  },
}

// Logs API (Super Admin only)
export const logsApi = {
  listFiles: async (filters?: { module?: string; date?: string }): Promise<LogListResponse> => {
    const response = await api.get('/admin/logs', { params: filters })
    return response.data
  },

  getContent: async (path: string, filters?: LogFilters): Promise<LogContentResponse> => {
    const response = await api.get('/admin/logs/content', {
      params: { path, ...filters },
    })
    return response.data
  },

  getDownloadUrl: (path: string): string => {
    const token = localStorage.getItem('token')
    return `${api.defaults.baseURL}/admin/logs/download?path=${encodeURIComponent(path)}&token=${token}`
  },
}

// E-Signing Settings API
export const esigningApi = {
  getProviders: async (): Promise<ESigningProviderMeta[]> => {
    const response = await api.get('/settings/esigning/providers')
    return response.data?.providers || []
  },

  getSettings: async (): Promise<ESigningSettings> => {
    const response = await api.get('/settings/esigning/settings')
    return response.data
  },

  updateSettings: async (data: UpdateESigningSettingsRequest): Promise<void> => {
    await api.put('/settings/esigning/settings', data)
  },

  testConnection: async (): Promise<ESigningTestConnectionResponse> => {
    const response = await api.post('/settings/esigning/settings/test')
    return response.data
  },
}

// ============================================================================
// Social Media Calendar API
// ============================================================================

// Social Media Calendars API
export const socialMediaCalendarsApi = {
  getAll: async (filters?: SocialMediaCalendarFilters): Promise<SocialMediaCalendar[]> => {
    const response = await api.get('/social-media/calendars', { params: filters })
    return response.data || []
  },

  getById: async (id: string): Promise<SocialMediaCalendar> => {
    const response = await api.get(`/social-media/calendars/${id}`)
    return response.data
  },

  create: async (data: CreateSocialMediaCalendarRequest): Promise<SocialMediaCalendar> => {
    const response = await api.post('/social-media/calendars', data)
    return response.data
  },

  update: async (id: string, data: UpdateSocialMediaCalendarRequest): Promise<SocialMediaCalendar> => {
    const response = await api.put(`/social-media/calendars/${id}`, data)
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/social-media/calendars/${id}`)
  },

  // Accounts under calendar
  getAccounts: async (calendarId: string): Promise<SocialMediaAccount[]> => {
    const response = await api.get(`/social-media/calendars/${calendarId}/accounts`)
    return response.data || []
  },

  createAccount: async (calendarId: string, data: CreateSocialMediaAccountRequest): Promise<SocialMediaAccount> => {
    const response = await api.post(`/social-media/calendars/${calendarId}/accounts`, data)
    return response.data
  },

  // Posts under calendar
  getPosts: async (calendarId: string, filters?: SocialMediaPostFilters): Promise<SocialMediaPost[]> => {
    const response = await api.get(`/social-media/calendars/${calendarId}/posts`, { params: filters })
    return response.data || []
  },

  createPost: async (calendarId: string, data: CreateSocialMediaPostRequest): Promise<SocialMediaPost> => {
    const response = await api.post(`/social-media/calendars/${calendarId}/posts`, data)
    return response.data
  },

  // Members under calendar
  getMembers: async (calendarId: string): Promise<CalendarMember[]> => {
    const response = await api.get(`/social-media/calendars/${calendarId}/members`)
    return response.data || []
  },

  addMember: async (calendarId: string, data: AddCalendarMemberRequest): Promise<CalendarMember> => {
    const response = await api.post(`/social-media/calendars/${calendarId}/members`, data)
    return response.data
  },

  updateMember: async (calendarId: string, userId: string, data: UpdateCalendarMemberRequest): Promise<CalendarMember> => {
    const response = await api.put(`/social-media/calendars/${calendarId}/members/${userId}`, data)
    return response.data
  },

  removeMember: async (calendarId: string, userId: string): Promise<void> => {
    await api.delete(`/social-media/calendars/${calendarId}/members/${userId}`)
  },
}

// Social Media Accounts API
export const socialMediaAccountsApi = {
  getById: async (accountId: string): Promise<SocialMediaAccount> => {
    const response = await api.get(`/social-media/accounts/${accountId}`)
    return response.data
  },

  update: async (accountId: string, data: UpdateSocialMediaAccountRequest): Promise<SocialMediaAccount> => {
    const response = await api.put(`/social-media/accounts/${accountId}`, data)
    return response.data
  },

  delete: async (accountId: string): Promise<void> => {
    await api.delete(`/social-media/accounts/${accountId}`)
  },

  testConnection: async (accountId: string): Promise<TestConnectionResponse> => {
    const response = await api.post(`/social-media/accounts/${accountId}/test-connection`)
    return response.data
  },
}

// Social Media Platforms API
export const socialMediaPlatformsApi = {
  // Get available platforms with their credential requirements
  getAll: async (): Promise<PlatformInfo[]> => {
    const response = await api.get('/social-media/platforms')
    return response.data || []
  },

  // Test credentials without saving
  testConnection: async (data: TestConnectionRequest): Promise<TestConnectionResponse> => {
    const response = await api.post('/social-media/test-connection', data)
    return response.data
  },
}

// Social Media Posts API
export const socialMediaPostsApi = {
  getPendingApproval: async (): Promise<SocialMediaPost[]> => {
    const response = await api.get('/social-media/posts/pending-approval')
    return response.data || []
  },

  getById: async (postId: string): Promise<SocialMediaPost> => {
    const response = await api.get(`/social-media/posts/${postId}`)
    return response.data
  },

  update: async (postId: string, data: UpdateSocialMediaPostRequest): Promise<SocialMediaPost> => {
    const response = await api.put(`/social-media/posts/${postId}`, data)
    return response.data
  },

  delete: async (postId: string): Promise<void> => {
    await api.delete(`/social-media/posts/${postId}`)
  },

  // Approval workflow
  requestApproval: async (postId: string): Promise<SocialMediaPost> => {
    const response = await api.post(`/social-media/posts/${postId}/request-approval`)
    return response.data
  },

  approve: async (postId: string): Promise<SocialMediaPost> => {
    const response = await api.post(`/social-media/posts/${postId}/approve`)
    return response.data
  },

  reject: async (postId: string, data: RejectPostRequest): Promise<SocialMediaPost> => {
    const response = await api.post(`/social-media/posts/${postId}/reject`, data)
    return response.data
  },

  markAsPosted: async (postId: string): Promise<SocialMediaPost> => {
    const response = await api.post(`/social-media/posts/${postId}/mark-posted`)
    return response.data
  },

  updateSchedule: async (postId: string, scheduledAt: string | null): Promise<SocialMediaPost> => {
    // Convert datetime-local format (YYYY-MM-DDTHH:mm) to ISO 8601 format for the backend
    const formattedDate = scheduledAt ? new Date(scheduledAt).toISOString() : null
    const response = await api.put(`/social-media/posts/${postId}/schedule`, { scheduled_at: formattedDate })
    return response.data
  },

  // Comments
  getComments: async (postId: string): Promise<SocialMediaPostComment[]> => {
    const response = await api.get(`/social-media/posts/${postId}/comments`)
    return response.data || []
  },

  createComment: async (postId: string, data: CreatePostCommentRequest): Promise<SocialMediaPostComment> => {
    const response = await api.post(`/social-media/posts/${postId}/comments`, data)
    return response.data
  },
}

// Social Media Comments API
export const socialMediaCommentsApi = {
  delete: async (commentId: string): Promise<void> => {
    await api.delete(`/social-media/comments/${commentId}`)
  },
}

// Social Media Media Upload API
export interface MediaUploadResponse {
  url: string
  file_name: string
  file_type: string
  file_size: number
}

export const socialMediaMediaApi = {
  upload: async (file: File): Promise<MediaUploadResponse> => {
    const formData = new FormData()
    formData.append('file', file)
    const response = await api.post('/social-media/media/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  },
}

// ============================================================================
// Social Media Publishing API
// ============================================================================

export interface PublishLogFilters {
  calendar_id?: string
  account_id?: string
  status?: PublishLogStatus
  date_from?: string
  date_to?: string
}

export const socialMediaPublishingApi = {
  // Publish post to accounts
  publishPost: async (postId: string, data: PublishPostRequest): Promise<PublishPostResponse> => {
    const response = await api.post(`/social-media/posts/${postId}/publish`, data)
    return response.data
  },

  // Get publish logs for a post
  getPublishLogs: async (postId: string): Promise<PostPublishLog[]> => {
    const response = await api.get(`/social-media/posts/${postId}/publish-logs`)
    return response.data || []
  },

  // List all publish logs with filters
  listPublishLogs: async (filters?: PublishLogFilters): Promise<PostPublishLog[]> => {
    const response = await api.get('/social-media/publish-logs', { params: filters })
    return response.data || []
  },
}

// ============================================================================
// Notifications API
// ============================================================================

export interface Notification {
  notification_id: string
  tenant_id: string
  user_id: string
  notification_type: string
  title: string
  message: string
  entity_type?: string
  entity_id?: string
  entity_name?: string
  actor_id?: string
  actor_name?: string
  is_read: boolean
  read_at?: string
  metadata?: Record<string, unknown>
  created_at: string
  expires_at?: string
}

export interface NotificationListResponse {
  notifications: Notification[]
  total: number
  unread_count: number
}

export interface NotificationListFilters {
  unread_only?: boolean
  entity_type?: string
  limit?: number
  offset?: number
}

export interface UnreadCountResponse {
  count: number
}

export const notificationsApi = {
  // Get notifications with pagination
  getNotifications: async (filters?: NotificationListFilters): Promise<NotificationListResponse> => {
    const response = await api.get<ApiResponse<NotificationListResponse>>('/notifications', { params: filters })
    return response.data.data
  },

  // Get unread count
  getUnreadCount: async (): Promise<UnreadCountResponse> => {
    const response = await api.get<ApiResponse<UnreadCountResponse>>('/notifications/unread-count')
    return response.data.data
  },

  // Mark a single notification as read
  markAsRead: async (notificationId: string): Promise<void> => {
    await api.post(`/notifications/${notificationId}/read`)
  },

  // Mark multiple notifications as read
  markMultipleAsRead: async (notificationIds: string[]): Promise<void> => {
    await api.post('/notifications/read', { notification_ids: notificationIds })
  },

  // Mark all notifications as read
  markAllAsRead: async (): Promise<void> => {
    await api.post('/notifications/read-all')
  },

  // Delete a notification
  deleteNotification: async (notificationId: string): Promise<void> => {
    await api.delete(`/notifications/${notificationId}`)
  },

  // Get WebSocket URL for real-time notifications
  getWebSocketUrl: (token: string): string => {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
    const baseUrl = import.meta.env.VITE_API_URL || ''
    const host = baseUrl.replace(/^https?:\/\//, '') || window.location.host
    return `${protocol}//${host}/api/notifications/ws?token=${encodeURIComponent(token)}`
  },
}

// ============================================================================
// Reconciliation API
// ============================================================================

import type {
  BankAccount,
  CreateBankAccountRequest,
  UpdateBankAccountRequest,
  BankAccountListResponse,
  BankStatement,
  StatementListResponse,
  BankTransaction,
  TransactionListResponse,
  UpdateTransactionStatusRequest,
  MatchToInvoiceRequest,
  CreateExpenseFromTransactionRequest,
  BulkUpdateStatusRequest,
  BulkUpdateResult,
  ReconciliationRule,
  CreateRuleRequest,
  UpdateRuleRequest,
  RuleListResponse,
  ReconciliationDashboard,
  RecordDecisionRequest,
  SuggestionResponse,
  LearningStats,
  // Smart Reconciliation Engine types
  RuleSuggestion,
  RuleSuggestionListResponse,
  RuleSuggestionStatus,
  RuleSuggestionCountResponse,
  AIMetrics,
  AIMetricsSummary,
  ReviewQueueListResponse,
  ReviewQueueFilters,
  ApproveTransactionRequest,
  ReviewQueueCountResponse,
  // AI Category Suggestion types
  AcceptCategorySuggestionRequest,
  AcceptCategorySuggestionResponse,
} from '@/types'

export interface BankAccountListFilters {
  page?: number
  page_size?: number
  search?: string
  active_only?: boolean
  sort_by?: string
  sort_order?: 'asc' | 'desc'
}

export interface StatementListFilters {
  page?: number
  page_size?: number
  bank_account_id?: string
  status?: string
  sort_by?: string
  sort_order?: 'asc' | 'desc'
}

export interface TransactionListFilters {
  page?: number
  page_size?: number
  bank_account_id?: string
  statement_id?: string
  status?: string
  direction?: string
  date_from?: string
  date_to?: string
  amount_min?: number
  amount_max?: number
  search?: string
  sort_by?: string
  sort_order?: 'asc' | 'desc'
}

export interface RuleListFilters {
  page?: number
  page_size?: number
  bank_account_id?: string
  active_only?: boolean
  search?: string
  sort_by?: string
  sort_order?: 'asc' | 'desc'
}

export const reconciliationApi = {
  // Bank Account endpoints
  bankAccounts: {
    list: async (filters?: BankAccountListFilters): Promise<BankAccountListResponse> => {
      const response = await api.get('/reconciliation/bank-accounts', { params: filters })
      return response.data
    },
    getById: async (id: string): Promise<BankAccount> => {
      const response = await api.get(`/reconciliation/bank-accounts/${id}`)
      return response.data
    },
    create: async (data: CreateBankAccountRequest): Promise<BankAccount> => {
      const response = await api.post('/reconciliation/bank-accounts', data)
      return response.data
    },
    update: async (id: string, data: UpdateBankAccountRequest): Promise<BankAccount> => {
      const response = await api.put(`/reconciliation/bank-accounts/${id}`, data)
      return response.data
    },
    delete: async (id: string): Promise<void> => {
      await api.delete(`/reconciliation/bank-accounts/${id}`)
    },
  },

  // Statement endpoints
  statements: {
    list: async (filters?: StatementListFilters): Promise<StatementListResponse> => {
      const response = await api.get('/reconciliation/statements', { params: filters })
      return response.data
    },
    getById: async (id: string): Promise<BankStatement> => {
      const response = await api.get(`/reconciliation/statements/${id}`)
      return response.data
    },
    upload: async (bankAccountId: string, file: File): Promise<BankStatement> => {
      const formData = new FormData()
      formData.append('bank_account_id', bankAccountId)
      formData.append('file', file)
      const response = await api.post('/reconciliation/statements/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      return response.data
    },
    delete: async (id: string): Promise<void> => {
      await api.delete(`/reconciliation/statements/${id}`)
    },
    reprocess: async (id: string): Promise<BankStatement> => {
      const response = await api.post(`/reconciliation/statements/${id}/reprocess`)
      return response.data
    },
  },

  // Transaction endpoints
  transactions: {
    list: async (filters?: TransactionListFilters): Promise<TransactionListResponse> => {
      const response = await api.get('/reconciliation/transactions', { params: filters })
      // The interceptor unwraps the response, so response.data is the transactions array
      // and pagination is attached to the response object
      const pagination = (response as any).pagination
      return {
        transactions: response.data || [],
        total: pagination?.total || 0,
        page: pagination?.page || 1,
        page_size: pagination?.limit || 20,
        total_pages: pagination?.total_pages || 1,
      }
    },
    getById: async (id: string): Promise<BankTransaction> => {
      const response = await api.get(`/reconciliation/transactions/${id}`)
      return response.data
    },
    updateStatus: async (id: string, data: UpdateTransactionStatusRequest): Promise<BankTransaction> => {
      const response = await api.put(`/reconciliation/transactions/${id}/status`, data)
      return response.data
    },
    matchToInvoice: async (id: string, data: MatchToInvoiceRequest): Promise<BankTransaction> => {
      const response = await api.post(`/reconciliation/transactions/${id}/match-invoice`, data)
      return response.data
    },
    createExpense: async (id: string, data: CreateExpenseFromTransactionRequest): Promise<BankTransaction> => {
      const response = await api.post(`/reconciliation/transactions/${id}/create-expense`, data)
      return response.data
    },
    bulkUpdateStatus: async (data: BulkUpdateStatusRequest): Promise<BulkUpdateResult> => {
      const response = await api.put('/reconciliation/transactions/bulk-status', data)
      return response.data
    },
    acceptCategorySuggestion: async (id: string, data: AcceptCategorySuggestionRequest): Promise<AcceptCategorySuggestionResponse> => {
      const response = await api.post(`/reconciliation/transactions/${id}/accept-category`, data)
      return response.data
    },
  },

  // Rule endpoints
  rules: {
    list: async (filters?: RuleListFilters): Promise<RuleListResponse> => {
      const response = await api.get('/reconciliation/rules', { params: filters })
      return response.data
    },
    getById: async (id: string): Promise<ReconciliationRule> => {
      const response = await api.get(`/reconciliation/rules/${id}`)
      return response.data
    },
    create: async (data: CreateRuleRequest): Promise<ReconciliationRule> => {
      const response = await api.post('/reconciliation/rules', data)
      return response.data
    },
    update: async (id: string, data: UpdateRuleRequest): Promise<ReconciliationRule> => {
      const response = await api.put(`/reconciliation/rules/${id}`, data)
      return response.data
    },
    delete: async (id: string): Promise<void> => {
      await api.delete(`/reconciliation/rules/${id}`)
    },
    toggle: async (id: string): Promise<ReconciliationRule> => {
      const response = await api.post(`/reconciliation/rules/${id}/toggle`)
      return response.data
    },
  },

  // Dashboard endpoints
  dashboard: {
    get: async (): Promise<ReconciliationDashboard> => {
      const response = await api.get('/reconciliation/dashboard')
      return response.data
    },
    getLearningStats: async (): Promise<LearningStats> => {
      const response = await api.get('/reconciliation/dashboard/learning')
      return response.data
    },
  },

  // Learning endpoints
  learning: {
    recordDecision: async (data: RecordDecisionRequest): Promise<void> => {
      await api.post('/reconciliation/learning/decisions', data)
    },
    getSuggestions: async (transactionId: string): Promise<SuggestionResponse> => {
      const response = await api.get(`/reconciliation/learning/suggestions/${transactionId}`)
      return response.data
    },
    getStats: async (): Promise<LearningStats> => {
      const response = await api.get('/reconciliation/learning/stats')
      return response.data
    },
  },

  // ============================================================================
  // Smart Reconciliation Engine Endpoints
  // ============================================================================

  // Review Queue endpoints
  reviewQueue: {
    list: async (filters?: ReviewQueueFilters): Promise<ReviewQueueListResponse> => {
      const response = await api.get('/reconciliation/review-queue', { params: filters })
      // The interceptor unwraps the response, so response.data is the transactions array
      // and pagination is attached to the response object
      const pagination = (response as any).pagination
      return {
        transactions: response.data || [],
        total: pagination?.total || 0,
        page: pagination?.page || 1,
        page_size: pagination?.limit || 20,
        total_pages: pagination?.total_pages || 1,
      }
    },
    getCount: async (): Promise<ReviewQueueCountResponse> => {
      const response = await api.get('/reconciliation/review-queue/count')
      return response.data
    },
    approve: async (id: string, data?: ApproveTransactionRequest): Promise<BankTransaction> => {
      const response = await api.post(`/reconciliation/review-queue/${id}/approve`, data)
      return response.data
    },
    reject: async (id: string): Promise<BankTransaction> => {
      const response = await api.post(`/reconciliation/review-queue/${id}/reject`)
      return response.data
    },
  },

  // Rule Suggestions endpoints
  ruleSuggestions: {
    list: async (status?: RuleSuggestionStatus): Promise<RuleSuggestionListResponse> => {
      const response = await api.get('/reconciliation/rule-suggestions', { params: status ? { status } : undefined })
      return response.data
    },
    getById: async (id: string): Promise<RuleSuggestion> => {
      const response = await api.get(`/reconciliation/rule-suggestions/${id}`)
      return response.data
    },
    getPendingCount: async (): Promise<RuleSuggestionCountResponse> => {
      const response = await api.get('/reconciliation/rule-suggestions/count')
      return response.data
    },
    accept: async (id: string): Promise<ReconciliationRule> => {
      const response = await api.post(`/reconciliation/rule-suggestions/${id}/accept`)
      return response.data
    },
    dismiss: async (id: string): Promise<void> => {
      await api.post(`/reconciliation/rule-suggestions/${id}/dismiss`)
    },
  },

  // AI Metrics endpoints
  aiMetrics: {
    getCurrentPeriod: async (): Promise<AIMetrics> => {
      const response = await api.get('/reconciliation/ai-metrics/current')
      return response.data
    },
    getHistory: async (startDate?: string, endDate?: string): Promise<AIMetrics[]> => {
      const response = await api.get('/reconciliation/ai-metrics/history', {
        params: { start_date: startDate, end_date: endDate },
      })
      return response.data
    },
    getSummary: async (): Promise<AIMetricsSummary> => {
      const response = await api.get('/reconciliation/ai-metrics/summary')
      return response.data
    },
  },
}

// ============================================================================
// Global Search API
// ============================================================================

import type { SearchResponse, GroupedSearchResponse, SearchEntityType } from '@/types'

export const searchApi = {
  // Search across all entities
  search: async (query: string, type?: SearchEntityType, limit?: number): Promise<SearchResponse> => {
    const params: Record<string, string | number> = { q: query }
    if (type) params.type = type
    if (limit) params.limit = limit
    const response = await api.get('/search', { params })
    return response.data
  },

  // Search with results grouped by entity type
  searchGrouped: async (query: string, limit?: number): Promise<GroupedSearchResponse> => {
    const params: Record<string, string | number> = { q: query }
    if (limit) params.limit = limit
    const response = await api.get('/search/grouped', { params })
    return response.data
  },
}

export default api
